module.exports = __webpack_public_path__ + "media/images/icon-sales-menu-488fec76f12afe9ca883458413549cfb.svg";